import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
	label: ReactNode
	error?: boolean
}

export default function TabLabel(props: Props) {
	return <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
		{props.label}
		{props.error ? <ErrorOutlineIcon color="error" sx={{ fontSize: 16 }} /> : null}
	</Box>
}
